import React, { FC, memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
    selectCurrentUser,
} from 'ducks/user';

import { ChatContainerProps } from './Chat.interface';
import Chat from './Chat';

export const ChatContainer: FC<ChatContainerProps> = memo(props => {
    const user = useSelector(selectCurrentUser);

    const userEmail = useMemo(() => {
        let domain = 'yandex-team.ru';

        if (user.affiliation === 'yango') {
            domain = 'yango-team.com';
        }

        return `${user.id}@${domain}`;
    }, [user]);

    return (
        <Chat userEmail={userEmail} {...props} />
    );
});
